import { ACCOUNT_SUMMARY_API } from '../constants/AppConstants';

export default async () => {
  try {
    const response = await fetch(ACCOUNT_SUMMARY_API);
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
